import { Molecule } from 'AppReact';
import styled from 'styled-components';
import { Popup } from './atoms';
import { BorderedImage, BorderedVideo, Empty } from 'atoms';
import { FileSvg, PDFDocumentSvg } from 'components/icons';

const template = styled.div`
  display: flex;
  position: relative;
  cursor: pointer;

  span {
    display: none;
  }

  &:hover {
    span {
      display: unset;
    }
  }
`;

export default Molecule({
  template,
  type: 'button',
  atoms: [
    {
      component: BorderedImage,
      name: 'Image',
      renderIf: ({ content_type }) => content_type?.includes('image'),
      displayValue: ({ url }) => url,
      displayState: ({ width, height }) => ({ width, height })
    },
    {
      component: BorderedVideo,
      name: 'Image',
      renderIf: ({ content_type }) => content_type?.includes('video'),
      displayValue: ({ url }) => url,
      displayState: ({ width, height, displayBackground }) => ({ width, height, displayBackground })
    },
    {
      component: Empty,
      name: 'Image',
      renderIf: ({ content_type }) => !content_type?.includes('video') && !content_type?.includes('image') && !content_type.includes('pdf'),
      displayValue: ({ width, height }) => FileSvg({ width, height }),
    },
    {
      component: Empty,
      name: 'Image',
      renderIf: ({ content_type }) => content_type?.includes('pdf'),
      displayValue: ({ width, height }) => PDFDocumentSvg({ width, height }),
    },
    {
      component: Popup,
      name: 'Popup',
      renderIf: ({ popup }) => !!popup,
      displayValue: ({ popup }) => popup.text,
      displayState: ({ popup }) => ({ position: popup.position })
    }
  ],
})